import { render, staticRenderFns } from "./External.vue?vue&type=template&id=6e4b3c3f&scoped=true&"
var script = {}
import style0 from "./External.vue?vue&type=style&index=0&id=6e4b3c3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b3c3f",
  null
  
)

export default component.exports